import React, { PureComponent } from "react";
import styled from "styled-components";
import "./style.scss";

export default class VideoLayout extends PureComponent {
  static defaultProps = {
    topic: null,
    video: null,
    backgroundColor: "#ffffff",
    marginContentTop: 0
  };
  render() {
    const { topic, video, backgroundColor, marginContentTop, children } = this.props;
    return (
      <Styled
        className="video-layout-component"
        backgroundColor={backgroundColor}
        marginContentTop={marginContentTop}
      >
        <div className="video-block">
          <div className="video">
            <iframe
              title={topic}
              width="100%"
              height="100%"
              src={`${video}?modestbranding=1&autohide=1&showinfo=0&controls=0&autoplay=1&loop=1`}
              frameBorder="0"
              allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            />
          </div>
          <div className="topic">{topic}</div>
        </div>
        <div className="content-block">
          <div className="bg-panel" />
          <div className="content">{children}</div>
        </div>
      </Styled>
    );
  }
}

const Styled = styled.div`
  .content-block {
    background-color: ${props => props.backgroundColor};
    .bg-panel {
      background-color: ${props => props.backgroundColor};
    }
  }
`;



// WEBPACK FOOTER //
// ./src/components/VideoLayout/index.js